<template>
  <va-modal
    id="cancelCallRequestModal"
    ref="cancelCallRequestModal"
    :value="isOpen"
    :cancelText="$t('modals.buttons.cancel')"
    :okText="$t('modals.buttons.submit')"
    @ok="onSubmit"
    @cancel="onCancel"
    size="large"
    :noOutsideDismiss="true"
    :okToClose="false"
    >
    <div slot="header" class="modal-title">
      <span>{{ $t('evocall.requests.cancel_header') }}</span>
    </div>

    <form class="evollu-form">

      <div class="row">
        <div class="col-12">
          <label>{{ $t('evocall.requests.created_at') }}:&nbsp;</label>
          <span class="is-bold"> {{ request.createdAt | localTime('DD MMMM YYYY HH:mm')  }}</span>
        </div>

        <div class="col-12">
          <label>{{ $t('evocall.requests.facility') }}:&nbsp;</label>
          <span class="is-bold">{{ request.facilityName ? request.facilityName : 'N/A' }}</span>
        </div>

        <div class="col-12">
          <label>{{ this.$t('evocall.requests.creator') }}:&nbsp;</label>
          <span class="is-bold">{{ request.dispenserNickname ? request.dispenserNickname : 'N/A' }}</span>
        </div>

        <!--<div class="col-12">
          <label>{{ this.$t('clinical.appointments.patient_name') }}:&nbsp;</label>
          <span class="is-bold">{{ request.customerName ? request.customerName : 'N/A' }}</span>
        </div>-->
      </div>

      <div style="height: 5px">

      </div>

      <div class="row">
        <div class="col-12">
          <label class="form-label">{{$t('evocall.inputs.cancelation_reason')}}</label>
          <multiselect
            v-model="form.data.cancel_reason"
            :options="requestCancelationReasons"
            track-by="id"
            :customLabel="option => $t(`evocall.requests.cancelation_reasons.${option.id}`)"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
            @click="isDropdownOpened = !isDropdownOpened"
            >
          </multiselect>
        </div>
      </div>

      <div v-if="userIsDispenser" style="height: 60px"/>
      <div v-else style="height: 120px"/>

      <!--<div class="row">
        <div class="col-12">
          <va-input
            v-model="form.data.cancel_reason_observations"
            :label="$t('evocall.requests.comment')"
            type="textarea"
            :placeholder="this.$t('evocal.requests.cancel_reason_observations_placeholder')"
            @input="form.errors.clear('cancel_reason_observations')"
            :minRows="3"
            :maxRows="8" />
        </div>
        <span class="small text-danger" v-show="form && form.errors.has('cancel_reason_observations')">
          {{ $t(`${form.errors.get('cancel_reason_observations')}`) }}
        </span>
      </div>-->
    </form>

  </va-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import Multiselect from 'vue-multiselect'
import { RequestService } from '@/api/VirtualWaitingRoomService'
import Errors from '@/utils/CustomNodeErrors'
import EventBus from "@/utils/EventBus";

export default {
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  components: {
    Multiselect
  },
  mounted: function () {
    this.isOpen = true
  },
  data: function () {
    return {
      isOpen: false,
      isDropdownOpened: false,
      form: {
        data: {
          cancel_reason: null,
        },
        errors: new Errors()
      }
    }
  },
  computed: {
    waitingRoomModuleKey: function () {
      return `virtualWaitingRoom`
    },
    ...mapGetters({
      userIsDispenser: 'auth/userIsDispenser'
    }),
    ...mapState({
      virtualWaitingRoomService (state) {
        return state.services.find(service => service.url === state.virtual_waiting_room_server) || null
      },

      requestCancelationReasons (state, getters) {
        if (this.virtualWaitingRoomService.user_permissions.some(perm => (perm.info_type === 100 && perm.access_type === 3))) {
          return Object.values(state[`${this.waitingRoomModuleKey}`].requestCancelationReasons)
        }
        else if(this.userIsDispenser) {
          return Object.values(state[`${this.waitingRoomModuleKey}`].requestCancelationReasons).filter(elem => elem.id !== 4 && elem.id !== 5 && elem.id !== 7)
        } else {
          return Object.values(state[`${this.waitingRoomModuleKey}`].requestCancelationReasons)
        }

      },
    }),
    canSubmitForm: function () {
      return this.form.data.cancel_reason !== null
    }
  },
  methods: {
    onSubmit: function () {
      if (this.canSubmitForm) {
        const formData = this.getFormData()
        RequestService.cancel(this.request.id, formData)
          .then(request => {
            this.showToast(this.$t('clinical.appointments.cancel_call_request_success'), this.$store.state.successToastOptions)
            //this.$emit('requestCanceled', { request })
            EventBus.$emit('modalClosed')
            this.onCancel()
          })
          .catch(errors => {
            this.showToast(this.$t('clinical.appointments.cancel_call_request_failed'), this.$store.state.errorToastOptions)

            if (errors.response && errors.response.status === 422) {
              this.form.errors.record(errors.response.data.errors, 'evocall.requests.cancel_call_errors.')
            }

            if (errors.hasOwnProperty('response') && errors.response.status === 406) {
              this.$emit('operation-not-permited', { errors })
            }
          })
      } else {
        this.showToast(this.$t('evocall.requests.cannot_cancel_request_missing_cancelation_reason'), this.$store.state.errorToastOptions)
      }
    },
    getFormData: function () {
      return {
        cancel_reason_id: this.form.data.cancel_reason ? this.form.data.cancel_reason.id : null,
      }
    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modalClosed')
      }, 250)
    }
  }
}
</script>
